import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VDialog,
    {
      staticStyle: { "z-index": "1000" },
      attrs: { width: "80%", fullscreen: _vm.$vuetify.breakpoint.xsOnly },
      on: { input: _vm.close },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        VCard,
        [
          _c(VCardTitle, [_vm._v("Inventory Lookup")]),
          _c(
            VCardText,
            [
              _c(
                "div",
                {
                  staticClass: "d-flex flex-column flex-md-row justify-center",
                },
                [
                  _c(VTextField, {
                    attrs: {
                      label: "Inventory ID",
                      placeholder: "Press enter or search to lookup inventory",
                      clearable: "",
                    },
                    on: {
                      keypress: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.search.apply(null, arguments)
                      },
                      "click:clear": _vm.clearSearch,
                    },
                    model: {
                      value: _vm.inventoryId,
                      callback: function ($$v) {
                        _vm.inventoryId = $$v
                      },
                      expression: "inventoryId",
                    },
                  }),
                  _c(
                    VBtn,
                    {
                      staticClass: "ml-0 ml-md-5 mt-3",
                      on: { click: _vm.search },
                    },
                    [_vm._v("Search")]
                  ),
                ],
                1
              ),
              _vm.inventory
                ? _c(
                    VSheet,
                    { staticClass: "my-5 pa-2", attrs: { elevation: 5 } },
                    [
                      _c("div", { staticClass: "text-h6 mx-4" }, [
                        _vm._v("Found Inventory"),
                      ]),
                      _c(
                        VSimpleTable,
                        { staticClass: "pa-4 table" },
                        [
                          _c("tr", [
                            _c("td", [_vm._v("ID")]),
                            _c("td", [_vm._v(_vm._s(_vm.inventory.id))]),
                          ]),
                          _c("tr", [
                            _c("td", [_vm._v("Product")]),
                            _c("td", [
                              _vm._v(_vm._s(_vm.inventory.productName)),
                            ]),
                          ]),
                          _c("tr", [
                            _c("td", [_vm._v("Status")]),
                            _c("td", [_vm._v(_vm._s(_vm.inventory.status))]),
                          ]),
                          _vm._l(_vm.inventory.fields, function (field) {
                            return _c("tr", { key: field.id }, [
                              _c("td", [_vm._v(_vm._s(field.field))]),
                              _c("td", [
                                field.type == "Number"
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatNumber")(
                                            field.fieldValueNumber
                                          )
                                        )
                                      ),
                                    ])
                                  : field.type == "Date"
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatDateYear")(
                                            field.fieldValueDate
                                          )
                                        )
                                      ),
                                    ])
                                  : _c("span", [
                                      _vm._v(_vm._s(field.fieldValueString)),
                                    ]),
                              ]),
                            ])
                          }),
                          _c("tr", [
                            _c("td", [_vm._v("Stock Time")]),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("formatDateYear")(
                                    _vm.inventory.stockTime
                                  )
                                )
                              ),
                            ]),
                          ]),
                          _c("tr", [
                            _c("td", [_vm._v("Quantity")]),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("formatNumber")(_vm.inventory.quantity)
                                )
                              ),
                            ]),
                          ]),
                          _c("tr", [
                            _c("td", [_vm._v("Unit")]),
                            _c(
                              "td",
                              [
                                _c("inventory-unit-details", {
                                  key: _vm.inventory.id,
                                  attrs: { count: _vm.inventory.unit },
                                  model: {
                                    value: _vm.inventory.id,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.inventory, "id", $$v)
                                    },
                                    expression: "inventory.id",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _c("tr", [
                            _c("td", [_vm._v("CoA")]),
                            _c(
                              "td",
                              [
                                _vm.inventory.coa &&
                                _vm.inventory.coa.length > 0
                                  ? _c(
                                      VMenu,
                                      {
                                        attrs: { "offset-y": "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function ({ on, attrs }) {
                                                return [
                                                  _c(
                                                    VBtn,
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          attrs: {
                                                            text: "",
                                                            color: "primary",
                                                          },
                                                        },
                                                        "v-btn",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _c(VIcon, [
                                                        _vm._v(
                                                          "mdi-certificate"
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2776282017
                                        ),
                                      },
                                      _vm._l(_vm.inventory.coa, function (coa) {
                                        return _c(
                                          VList,
                                          { key: coa.id, staticClass: "pa-5" },
                                          [
                                            _c(
                                              VListItem,
                                              { attrs: { "two-line": "" } },
                                              [
                                                _c(
                                                  VListItemContent,
                                                  [
                                                    _c(VListItemTitle, [
                                                      _vm._v(" Test Time "),
                                                    ]),
                                                    _c(VListItemSubtitle, [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatDateYear"
                                                            )(coa.testTime)
                                                          ) +
                                                          " "
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              VListItem,
                                              { attrs: { "two-line": "" } },
                                              [
                                                _c(
                                                  VListItemContent,
                                                  [
                                                    _c(VListItemTitle, [
                                                      _vm._v(" Technician "),
                                                    ]),
                                                    _c(VListItemSubtitle, [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            coa.technician
                                                          ) +
                                                          " "
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              VListItem,
                                              { attrs: { "two-line": "" } },
                                              [
                                                _c(
                                                  VListItemContent,
                                                  [
                                                    _c(VListItemTitle, [
                                                      _vm._v(" Sample Name "),
                                                    ]),
                                                    _c(VListItemSubtitle, [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            coa.sampleName
                                                          ) +
                                                          " "
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              VListItem,
                                              { attrs: { "two-line": "" } },
                                              [
                                                _c(
                                                  VListItemContent,
                                                  [
                                                    _c(VListItemTitle, [
                                                      _vm._v(" Program "),
                                                    ]),
                                                    _c(VListItemSubtitle, [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(coa.program) +
                                                          " "
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              VListItem,
                                              { attrs: { "two-line": "" } },
                                              [
                                                _c(
                                                  VListItemContent,
                                                  [
                                                    _c(VListItemTitle, [
                                                      _vm._v(" Quality "),
                                                    ]),
                                                    _c(VListItemSubtitle, [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(coa.quality) +
                                                          " "
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      }),
                                      1
                                    )
                                  : _c("div", [_vm._v("N/A")]),
                              ],
                              1
                            ),
                          ]),
                        ],
                        2
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            VCardActions,
            [
              _c(VSpacer),
              _c(
                VBtn,
                {
                  staticClass: "mb-5",
                  attrs: { disabled: !_vm.inventory, color: "primary" },
                  on: { click: _vm.submit },
                },
                [_vm._v(" Submit ")]
              ),
              _c(
                VBtn,
                {
                  staticClass: "mb-5",
                  on: {
                    click: function ($event) {
                      _vm.dialog = false
                      _vm.close()
                    },
                  },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(VSpacer),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }